import {
  Award,
  FileText,
  GraduationCap,
  HeartPulse,
  ShieldCheck,
  ScrollText,
} from "lucide-react";

/** Tipologie documenti personali OSS (allineate al backend). */
export const OSS_PERSONALE_DOC_TYPES = [
  {
    key: "attestato_oss",
    label: "Attestato OSS",
    description: "Attestato di qualifica OSS",
    Icon: Award,
    iconWrap: "bg-sky-50 text-sky-600 ring-sky-100",
  },
  {
    key: "documenti",
    label: "Documenti",
    description: "Documenti anagrafici e personali",
    Icon: FileText,
    iconWrap: "bg-slate-50 text-slate-600 ring-slate-100",
  },
  {
    key: "corsi",
    label: "Corsi",
    description: "Attestati di corsi di formazione",
    Icon: GraduationCap,
    iconWrap: "bg-violet-50 text-violet-600 ring-violet-100",
  },
  {
    key: "blsd",
    label: "BLSD",
    description: "Certificazione Basic Life Support",
    Icon: HeartPulse,
    iconWrap: "bg-rose-50 text-rose-600 ring-rose-100",
  },
  {
    key: "haccp",
    label: "HACCP",
    description: "Attestato formazione igiene alimentare",
    Icon: ShieldCheck,
    iconWrap: "bg-emerald-50 text-emerald-600 ring-emerald-100",
  },
  {
    key: "certificati",
    label: "Certificati",
    description: "Altri certificati professionali",
    Icon: ScrollText,
    iconWrap: "bg-amber-50 text-amber-600 ring-amber-100",
  },
];

export function labelForOssDocType(key) {
  return OSS_PERSONALE_DOC_TYPES.find((t) => t.key === key)?.label || key;
}
